import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

import BuildingsReducer from './buildings/reducer'
import clientsReducer from './clients/reducer'
import contractReducer from './contracts/reducer'
import paymentReducer from './payments/reducer'
import phasesReducer from './phases/reducer'
import projectReducer from './project/reducer'
import settlementPriceReducer from './settelmentPrices/reducer'
import unitReducer from './units/reducer'
import ModalReducer from "./modal/reducer"

//User
import userReducer from './user/reducer'

//Reporting
import ReportReducer from './report/reducer'
import EmailReducer from './email/reducer'


const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    User: userReducer,
    ReportReducer: ReportReducer,
    Buildings: BuildingsReducer,
    Clients: clientsReducer,
    Contract: contractReducer,
    Payment: paymentReducer,
    Phases: phasesReducer,
    Project: projectReducer,
    SettlementPrices: settlementPriceReducer,
    Unit: unitReducer,
    Modal: ModalReducer,
    Email: EmailReducer,
});

export default rootReducer;
